import React, { memo } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { AboutUsBg } from "../../assets/img";
import { FaHome } from "react-icons/fa";
import "./PagesTopSection.css";
import { useTranslation } from "react-i18next";

const BreadcrumbArrow = ({ direction }) =>
	direction === "rtl" ? (
		<IoIosArrowBack className='text-slate-200' />
	) : (
		<IoIosArrowForward className='text-slate-200' />
	);

const PagesTopSection = memo(({ pageTitle, parentPageTitle, pathName }) => {
	const { t, i18n } = useTranslation();
	const direction = i18n?.language === "ar" ? "rtl" : "ltr";

	return (
		<section className='bg-gradient-colors py-10 pages-top-section'>
			<h2 className='md:text-2xl text-xl md:font-medium font-normal text-white mb-6'>
				{pageTitle}
			</h2>
			<div className='flex justify-center items-center gap-2 relative z-10'>
				<Link
					to='/'
					className='text-white text-md font-normal flex justify-start items-center gap-1'>
					<FaHome />
					{t("home")}
				</Link>

				{parentPageTitle && (
					<>
						<BreadcrumbArrow direction={direction} />
						<Link to={pathName} className='text-slate-100 text-md font-light'>
							{parentPageTitle}
						</Link>
					</>
				)}

				<BreadcrumbArrow direction={direction} />
				<span className='text-slate-200 text-md font-light'>{pageTitle}</span>
			</div>

			<div className='circle-shape'>
				<img
					loading='lazy'
					className='w-1/3 opacity-5'
					src={AboutUsBg}
					alt='Background'
				/>
			</div>
		</section>
	);
});

export default PagesTopSection;
